import { Tooltip } from 'primereact/tooltip';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface LimitTooltipProps {
  id: string;
  direction?: any;
  tooltipText?: string;
}

const LimitTooltipComponent: React.FC<LimitTooltipProps> = ({
  id,
  direction = 'top',
  tooltipText = 'reachedLimit',
}) => {
  const { t } = useTranslation();

  return (
    <Tooltip
      target={`#${id}`}
      className={`tooltip--${direction}`}
      position={direction}
      style={{ width: '220px' }}
      autoHide={false}
      hideDelay={100}
    >
      <div dangerouslySetInnerHTML={{ __html: t(tooltipText) }} />
    </Tooltip>
  );
};

export default LimitTooltipComponent;
